const _i18_error = {
  type: {
    EN: `Type required.`,
    KO: `Type required.`,
    JP: `タイプは必須です`
  },
  question: {
    EN: `Question required.`,
    KO: `Question required.`,
    JP: `質問が必要です`
  },
  registed: {
    EN: `registed failed`,
    KO: `registed failed`,
    JP: `登録に失敗しました`
  }
}

const i18n_toastr = { _i18_error }

export default i18n_toastr